import React, {useEffect} from "react";
import {useHistory} from "../routing";
import {showMessage} from "react-native-flash-message";
import {Mixpanel} from "../utils/mixpanel";

const CartPurchaseSuccessScreen = () => {
    const history = useHistory();

    useEffect(() => {
        Mixpanel.track("Successful cart purchase");
        showMessage({
            message: "Täname ostu eest, audioraamat lisatakse Sinu riiulile.",
            type: "success",
        });
        history.push("/");
    }, []);

    return null;
};

export default CartPurchaseSuccessScreen;
